module.exports = __webpack_public_path__ + "media/assets/images/refresh-5ad0bc377ac27664fa6e085e4deee0ea.svg";